
<template>
  <div class="text-wrap">
    <div class="line left"></div>
    <span class="text">{{title}}</span>
    <div class="line reverse"></div>
  </div>
</template>
<script>
export default {
  name: 'split-line',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "~@/assets/styles/main.scss";
  .text-wrap {
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    display: flex;
    width: 100%;
    .line {
      height: 1PX;
      flex:1;
      background: linear-gradient(left,rgba(255,255,255,0) 0%, #B8B8B8 100%);
      &.left {
        top: 50%;
        left: 0;
      }
      &.reverse {
        top: 50%;
        right: 0;
        transform: scaleX(-1);
      }
    }
    .text {
      padding: 0px 20px;
      font-size: 28px;
      position: relative;
      font-family: Aspira Regular;
      color: #666666;
      text-align: left;
    }
  }
</style>
